import { ERP } from '../_base/endpoint';
import axios from 'axios';


class tipoDocumentoService {
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/tipo-documento`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarExcluirPlaca() {
        const response = await axios
            .get(`${ERP}administracion/tipo-documento/excluir-placa`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new tipoDocumentoService();